import Vue from "vue";

import { URL_API } from "../../settings/apiConnect";

export default {
  actions: {
    async getTrayTypesData(context) {
      const response = await Vue.axios.get(`${URL_API}traytype`);
      let data = response["data"];
      context.commit("updateTrayTypesData", data);
    },
    async createTrayTypeData(context, name) {
      const config = {};
      const body = {
        name: name
      };
      await Vue.axios.post(`${URL_API}traytype/store`, body, config);
      context.dispatch("getTrayTypesData");
    },
    async pushTrayTypeData(context, { id, name }) {
      const config = {};
      const body = {
        id: id,
        name: name
      };
      await Vue.axios.post(`${URL_API}traytype/update`, body, config);
      context.dispatch("getTrayTypesData");
    },
    async destroyTrayTypeData(context, id) {
      const config = {};
      const body = {
        id: id
      };
      await Vue.axios.post(`${URL_API}traytype/destroy`, body, config);
      context.dispatch("getTrayTypesData");
    }
  },
  mutations: {
    updateTrayTypesData(state, trayTypesData) {
      state.trayTypesData = trayTypesData;
    }
  },
  state: {
    trayTypesData: []
  },
  getters: {
    allTrayTypesData(state) {
      return state.trayTypesData;
    }
  }
};